import script from "./clientInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./clientInfo.vue?vue&type=script&setup=true&lang=js"

import "./clientInfo.vue?vue&type=style&index=0&id=9faf111e&lang=css"

const __exports__ = script;

export default __exports__